import { UploadBexActions, EUploadBexActions } from '../actions/upload-bex.actions';
import { isLoading } from '../../../security/security-authentication/store/selectors/authentication.selectors';

export const initialUploadBexFileState: IUploadBexFileState = {
    currentBex: null,
    currentBexOnServer: null,
    isLoading: false,
    isLoadingHistory: false,
    isLoadingTraces: false,
    canReload: true,
    status: 'NotStarted',
    applyStatus: '',
    historyBex: null,
    bexFileTraces: null,
    maintenanceReasons: []
}

export function UploadBexFileReducer(state = initialUploadBexFileState, action: UploadBexActions): IUploadBexFileState {
    switch (action.type) {
        case EUploadBexActions.SetLocalBexFile: {
            const newState: IUploadBexFileState = {
                ...state,
                currentBex: action.payload
            }
            return newState;
        }

        case EUploadBexActions.RemoveSelectedBexFile: {
            const newState: IUploadBexFileState = {
                ...initialUploadBexFileState,
                historyBex: _.cloneDeep(state.historyBex)
            }
            return newState;
        }

        case EUploadBexActions.UploadBexFile: {
            const newState: IUploadBexFileState = {
                ...state,
                isLoading: true
            }
            return newState;
        }

        case EUploadBexActions.UploadBexFileSuccess: {
            const newState: IUploadBexFileState = {
                ...state,
                isLoading: false,
                canReload: true
            }
            return newState;
        }

        case EUploadBexActions.GetBexHistory: {
            const newState: IUploadBexFileState = {
                ...state,
                isLoadingHistory: true
            }
            return newState;
        }

        case EUploadBexActions.GetBexHistorySuccess: {
            const newState: IUploadBexFileState = {
                ...state,
                isLoadingHistory: false,
                historyBex: [...action.payload]
            }
            return newState;
        }

        case EUploadBexActions.DownloadTraceFile: {
            const historyBex = _.cloneDeep(state.historyBex);
            historyBex.map((bex, i) => {
                if (bex.Id === action.payload){
                   historyBex[i].isDownloading = true;
                 }
                 else{
                    delete historyBex[i].isDownloading;
                 }
               });

            const newState: IUploadBexFileState = {
                ...state,
                isLoadingTraces: true,
                historyBex
            }
            return newState;
        }

        case EUploadBexActions.DownloadTraceFileSuccess: {
            const historyBex = _.cloneDeep(state.historyBex);
            historyBex.forEach((bex)=> delete bex.isDownloading)
            const newState: IUploadBexFileState = {
                ...state,
                isLoadingTraces: false,
                bexFileTraces: { ...action.payload },
                historyBex
            }
            return newState;
        }

        case EUploadBexActions.GetCurrentBEXFromServer: {
            const newState: IUploadBexFileState = {
                ...state,
                isLoading: true,
                canReload: false
            }
            return newState;
        }

        case EUploadBexActions.GetCurrentBEXFromServerSuccess: {
            const newState: IUploadBexFileState = {
                ...state,
                isLoading: false,
                applyStatus: state.applyStatus === 'LoadingReasons' ? 'LoadingReasons' : action.payload.BEX.DescriptionStateBEX,
                currentBexOnServer: { ...action.payload },
                status: 'NotStarted',
                canReload: true
            }
            return newState;
        }

        case EUploadBexActions.GetObjectListMaintenanceReasons: {
          const newState: IUploadBexFileState = {
              ...state,
              isLoading: true,
              applyStatus: 'LoadingReasons'
          }
          return newState;
      }

        case EUploadBexActions.GetObjectListMaintenanceReasonsSuccess: {
            const newState: IUploadBexFileState = {
                ...state,
                maintenanceReasons: [...action.payload],
                applyStatus: null,
                isLoading: false
            }
            return newState;
        }

        case EUploadBexActions.ApplyBexUpload: {
            const newState: IUploadBexFileState = {
                ...state,
                isLoading: true,
                canReload: false
            }
            return newState;
        }

        case EUploadBexActions.ApplyBexUploadSuccess: {
            const newState: IUploadBexFileState = {
                ...initialUploadBexFileState
            }
            return newState;
        }

        case EUploadBexActions.GetBexImportStatusSuccess: {
            const newState: IUploadBexFileState = {
                ...state,
                status: action.payload
            }
            return newState;
        }

        case EUploadBexActions.AvoidReload: {
            const newState: IUploadBexFileState = {
                ...state,
                canReload: false
            }
            return newState;
        }

        case EUploadBexActions.AllowReload: {
            const newState: IUploadBexFileState = {
                ...state,
                canReload: true
            }
            return newState;
        }

        default: {
            return state;
        }
    }
}
